export const ADDCARTLOADING = "ADDCARTLOADING"
export const ADDCARTLOADINGERROR = "ADDCARTLOADINGERROR"
export const ADDCARTSUCCESS = "ADDCARTSUCCESS"



export const GETCARTLOADING = "GETCARTLOADING"
export const GETCARTLOADINGERROR = "GETCARTLOADINGERROR"
export const GETCARTSUCCESS = "GETCARTSUCCESS"



export const UPDATECARTLOADING = "UPDATECARTLOADING"
export const UPDATECARTLOADINGERROR = "UPDATECARTLOADINGERROR"
export const UPDATECARTSUCCESS = "UPDATECARTSUCCESS"



export const DELETECARTLOADING = "DELETECARTLOADING"
export const DELETECARTLOADINGERROR = "DELETECARTLOADINGERROR"
export const DELETECARTSUCCESS = "DELETECARTSUCCESS"